@if ((loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((loading$ | async) === false) {
  <div>
    <div class="mb-[15px] flex justify-between" [ngStyle]="{ width: (width$ | async) + 'px' }">
      <!-- Planned Visit Methodology Dropdown -->
      <div>
        <p class="text-m mb-2">Planned Visit Methodology</p>
        <ng-select
          class="planned-visit-methodology-select w-64"
          data-pendo-id="planned-visit-methodology-select"
          [multiple]="false"
          [clearable]="false"
          [searchable]="false"
          [formControl]="selectedPlannedVisitMethodologyFormControl"
          [items]="plannedVisitMethodologyOptions"
          (change)="onPlannedVisitMethodologySelect()"
          [auxTooltip]="settingTooltip()"
          bindValue="value"
          bindLabel="label"
        ></ng-select>
      </div>
    </div>

    @if (flags().investigatorDiscontinuationRate) {
      <aux-discontinuation-rate-radio
        [disableTooltip]="settingTooltip()"
        class="block max-w-[600px]"
      />
    }

    <aux-table-panel class="adjustment-panel mb-16 mt-6 w-full py-7">
      <div class="my-4 flex flex-col items-start space-y-2">
        <div class="flex w-full items-center justify-between px-4">
          <aux-checkbox
            class="text-m font-medium"
            [disabled]="!this.editMode()"
            data-pendo-id="investigator-auto-historical-adjustments-checkbox"
            [(ngModel)]="applyAutoHistoricalAdjustments"
            (customChange)="onClickCheckbox($event)"
          >
            <span [ngClass]="{ 'cursor-not-allowed': !this.editMode() }">
              Apply Auto-Historical Adjustments to Investigator
            </span>
          </aux-checkbox>

          <div class="flex items-center space-x-4">
            <aux-button
              variant="secondary"
              label="Expense Detail"
              icon="Eye"
              [onClick]="handleInMonthAdjustmentClick.bind(this)"
              data-pendo-id="expense-default-back-to-in-month-adjustments"
            />
            <div class="h-full">
              <hr style="width: 1px; height: 40px" class="bg-gray-300" />
            </div>

            <aux-export-excel-button
              className="ml-1"
              [clickFN]="onExportExpenseDefaults.bind(this)"
              [loading]="(isBtnLoading('export') | async) === true"
              [disabled]="(isBtnLoading('export') | async) === true"
              [spinnerSize]="7"
              pendoTag="expense-defaults-excel-export-button"
            />

            @if (editMode() === false) {
              <div
                [auxTooltip]="editButtonTooltip().length === 1 ? editButtonTooltip()[0] : ''"
                [template]="editButtonTooltip().length > 1 ? errorArrayTooltip : undefined"
              >
                <aux-button
                  [disabled]="isEditDisabled()"
                  (click)="onEditMode()"
                  variant="primary"
                  icon="Pencil"
                  label="Edit"
                />
              </div>
            }

            @if (editMode() === true) {
              <ng-container>
                <aux-button variant="secondary" icon="X" label="Cancel" (click)="onCancel()" />
                @if (editMode() === true) {
                  <aux-button
                    label="Save"
                    variant="success"
                    [disabled]="!saveCheck()"
                    [auxTooltip]="saveButtonTooltip()"
                    [onClick]="saveChanges.bind(this)"
                    icon="Check"
                  />
                }
              </ng-container>
            }
          </div>
        </div>
      </div>
      <div class="w-full">
        <ag-grid-angular
          class="ag-theme-aux expense-default-table flat-table-theme w-full min-w-[685px] max-w-full tabular-nums"
          domLayout="autoHeight"
          [gridOptions]="gridOptions"
          [rowData]="gridData$ | async"
          (gridReady)="onGridReady($event)"
          auxStickyGrid
        />
      </div>
    </aux-table-panel>
  </div>
}

<ng-template #errorArrayTooltip>
  <div class="rounded-[4px] py-2 pl-6 pr-4 text-white">
    <ul class="list-disc whitespace-nowrap">
      @for (err of editButtonTooltip(); track $index) {
        <li>{{ err }}</li>
      }
    </ul>
  </div>
</ng-template>
